import http from "./HttpService";

const BASE_SERVICE_URL = "pages-service";

export default {
  getCustomerPages(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/pages/customer/raw`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getMerchantMechanics(request) {
    return new Promise((resolve, reject) => {
      http
          .get(
              `${BASE_SERVICE_URL}/pages/customer/guidelines`,
              request.header
          )
          .then(response => {
            return resolve(response);
          })
          .catch((status, errors) => {
            reject(status, errors);
          });
    });
  }
};
